module.exports = __webpack_public_path__ + "img/安卓 1@2x.736cf676.png";